import { connect } from 'react-redux';
import AuctionImages from 'components/auctions/AuctionImages';
import {
  clearDeleteImages,
  clearRemoveImageLicensePlate,
  clearReorderImages,
  clearUploadImages,
  deleteImages,
  reorderImages,
  removeImageLicensePlate,
  uploadImages,
} from 'data/auctions/Auctions.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = state =>
  ReduxHelper.mapStateWithLookups(
    ReduxHelper.extract(
      state,
      'app.user',
      'auctions.uploadImages->data',
      'auctions.uploadImagesError->error',
      'auctions.uploadingImages->uploading',
      'remote#auctions.removeImageLicensePlate',
      'remote#auctions.deleteImages',
      'remote#auctions.reorderImages'
    ),
    state,
    'auctionStatuses',
    'partyTypes'
  );

const mapDispatchToProps = (dispatch, ownProps) => ({
  upload: files => dispatch(uploadImages(ownProps.auction.ID, files)),
  onRemoveLicensePlate: (imageId, obj) =>
    dispatch(removeImageLicensePlate(ownProps.auction.ID, imageId, obj)),
  onDelete: ids => dispatch(deleteImages(ownProps.auction.ID, ids)),
  onClearRemoveImageLicensePlate: () =>
    dispatch(clearRemoveImageLicensePlate()),
  onClearReorderImages: () => dispatch(clearReorderImages()),
  onReorderImages: imageIds =>
    dispatch(reorderImages(ownProps.auction.ID, imageIds)),
  clear: () => {
    dispatch(clearDeleteImages());
    dispatch(clearReorderImages());
    dispatch(clearUploadImages());
    dispatch(clearRemoveImageLicensePlate());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AuctionImages);
